<template>
  <nav>
    <v-app-bar app color="primary" dark height="70">
      <v-app-bar-nav-icon @click="drawer=!drawer" class="mr-4"></v-app-bar-nav-icon>

      <v-toolbar-title class="d-flex justify-center flex-grow-1">
        <v-img contain transition="fade-transition" max-height="60" alt="TinyGS logo" src="../assets/logo.svg" />
      </v-toolbar-title>

      <div class="d-none d-md-flex align-center">
        <v-btn icon class="mr-2" v-if="user">
          <v-icon @click="$router.push(`/user/${user}`)" large>mdi-account-circle</v-icon>
        </v-btn>
        <v-btn @click="logout()" color="primary" class="lighten-1 mr-2" depressed v-if="user">
          <span>Sign Out</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </v-btn>
        <v-btn v-if="!user" color="primary" class="lighten-1 mr-2" @click="openModal">
          <v-icon left>mdi-login</v-icon> <span class="d-none d-lg-inline">Login</span>
        </v-btn>
        <v-btn v-if="!user" color="primary" class="lighten-1 mr-2" @click="openRegistrationPopup">
          <v-icon left>mdi-account-plus</v-icon> <span class="d-none d-lg-inline">Register</span>
        </v-btn>
        <v-btn
              color="primary"
              class="lighten-1 ml-2"
              href="https://www.paypal.com/donate/?hosted_button_id=P3ZY6B9AQEFZA"
              target="_blank"
              rel="noopener noreferrer"
              >
              <img
              src="https://static.tinygs.com/PayPal.png"
              alt="PayPal"
              height="20"
              style="vertical-align: middle; margin-right: 5px;"
              />
              Donate
          </v-btn> 

</div>

      <div class="d-flex d-md-none">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="user" @click="$router.push(`/user/${user}`)">
              <v-list-item-icon>
                <v-icon>mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Profile</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="user" @click="logout()">
              <v-list-item-icon>
                <v-icon>mdi-exit-to-app</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!user" @click="openModal">
              <v-list-item-icon>
                <v-icon>mdi-login</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!user" @click="openRegistrationPopup">
              <v-list-item-icon>
                <v-icon>mdi-account-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Register</v-list-item-title>
            </v-list-item>
            <v-list-item href="https://www.paypal.com/donate/?hosted_button_id=P3ZY6B9AQEFZA" target="_blank" rel="noopener noreferrer">
              <v-list-item-icon>
                <v-icon>mdi-heart</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Donate</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar >
    <v-navigation-drawer disable-resize-watcher v-model="drawer" app color="primary" class="darken-1">
      <div class="d-flex justify-center mt-3 mb-4">
        <v-img contain max-height="90" transition="scale-transition" alt="TinyGS logo" src="../assets/logo.svg" />
      </div>
      <v-divider color="white"></v-divider>
      <v-list dense>
        <v-list-item-group flat class="white--text">
          <v-list-item dark v-for="link in links" :key="link.text" router :to="link.path">
            <v-list-item-icon>
              <v-icon v-text="link.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="link.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group dense
          :value="false"
          prepend-icon="$satellite"
          no-action
          sub-group>
          <template v-slot:activator>
            <v-list-item-content flat class="white--text">
              <v-list-item-title dark>Satellites</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item dark v-for="link in satellites" :key="link.text" router :to="link.path">
          <v-list-item-content>
              <v-list-item-title v-text="link.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group dense
          :value="false"
          prepend-icon="$rotateOrbit"
          no-action
          sub-group
     >

          <template v-slot:activator>
            <v-list-item-content flat class="white--text">
            <v-list-item-title >About</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item dark v-for="link in about" :key="link.text" router :to="link.path">
            <v-list-item-content>
              <v-list-item-title v-text="link.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div>
      <v-dialog v-model="dialog" persistent max-width="500px" @opened="onDialogOpened">
        <v-card>
          <v-card-title>
            <span class="headline">Request Weblogin</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p><b>Only</b> for already registered users </p>
            <v-text-field
              v-model="email"
              label="Enter your email"
              :class="{ 'input-error': emailError }"
              @input="validateEmail"
              :error-messages="emailError ? [emailError] : []"
            ></v-text-field>

            <div id="turnstile-container"></div>
            <div v-if="turnstileError" class="error-message">{{ turnstileError }}</div>
            <div v-if="requestMessage" class="request-message">{{ requestMessage }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="requestLogin" :loading="isLoading" :disabled="!isFormValid || isLoading">Request Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="registrationDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Registration Information</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeRegistrationPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p>To register for tinyGS, you need to join our official Telegram group:</p>
            <a href="https://t.me/joinchat/DmYSElZahiJGwHX6jCzB3Q" target="_blank">
              https://t.me/joinchat/DmYSElZahiJGwHX6jCzB3Q
            </a>
            <p></p>
            <p>Please note that registration through the Telegram group is currently the only method available.<br>We plan to add new registration methods in the near future.</p><p></p>

          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </nav>
</template>


<script>
export default {
  props: [
    "user"
  ],
  data() {
    return {

      dialog: false,
      registrationDialog: false,
      email: '',
      emailError: '',
      turnstileError:'',
      turnstileToken: null,
      turnstileInstance: null,
      isFormValid: false,
      isLoading: false,
      requestMessage:'',

      drawer: false,
      links: [
        { text: 'Home', icon: 'mdi-home', path: '/' },
        { text: 'Stations', icon: '$station', path: '/stations' },
        { text: 'Packets', icon: 'mdi-file-document-outline', path: '/packets' },
      ],

      satellites: [
        { text: 'Active Satellites',  icon: '$satellite',  path: '/satellites' },
        { text: 'FSK Satellites', icon: '$satellite', path: '/satellitesFSK' },
        { text: 'Starlink Satellites', icon: '$satellite', path: '/satellitesSL' },
        { text: 'Inactive Satellites', icon: '$satellite', path: '/satellitesIna' },
        { text: 'Future Satellites', icon: '$satellite', path: '/satellitesFut' },
        { text: 'Balloons', icon: '$balloon', path: '/balloons' },
    ],
      about: [
        { text: 'Meet the team', icon: 'mdi-home', path: '/about' },
        { text: 'History', icon: '$station', path: '/history' },
        { text: 'Terms', icon: '$station', path: '/terms' },
      ],

    }
  },
  watch:{
    email(){
      this.validateForm();
    }
  },
  methods: {

      logout() {
          localStorage.removeItem("userId");
          localStorage.removeItem("sessionToken");
          this.$emit("logout", true);
        this.$router.push('/');
      },

    
    beforeDestroy() {
        if (this.turnstileInstance) {
            this.turnstileInstance.remove();
        }
    },

    openModal() {
      this.dialog = true;
      this.showModal = true;
      this.$nextTick(() => {
        this.initializeTurnstile();
      });
    },
    closeModal() {
       this.dialog = false;
       this.showModal = false;
        this.email = '';
        this.emailError = '';
        this.turnstileError = '';
        this.requestMessage = '';
        this.turnstileToken = null;
        if (this.turnstileInstance) {
            this.turnstileInstance.reset();
            this.turnstileInstance.remove();
            this.turnstileInstance = null;
        }
    },
    openRegistrationPopup() {
      this.registrationDialog = true;
    },
    closeRegistrationPopup() {
      this.registrationDialog = false;
    },
    initializeTurnstile() {
        if (window.turnstile && !this.turnstileInstance) {
            this.turnstileInstance = window.turnstile.render('#turnstile-container', {
                sitekey: '0x4AAAAAAA4Ls89Ok1pJ_hw-', // Replace with your key
                callback: (token) => {
                    this.turnstileToken = token;
                    this.validateForm();
                },
                'error-callback': () => {
                  this.turnstileError= "Captcha Error, please try again"
                  this.validateForm();
                },
                'expired-callback': () => {
                  this.turnstileError= "Captcha Expired, please try again"
                  this.validateForm();
                },
            });
        }
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email) {
        this.emailError = 'Email is required';
      } else if (!emailRegex.test(this.email)) {
        this.emailError = 'Invalid email format';
      } else {
        this.emailError = '';
      }
    },
    validateForm(){
       this.isFormValid = this.emailError === '' && this.turnstileToken !== null;
    },
    async requestLogin() {
      this.validateEmail();
      if (!this.isFormValid) {
        return;
      }
      this.isLoading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API_ENDPOINT}/weblogin/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email, turnstile: this.turnstileToken }),
        });
        const data = await response.json()
        if(response.ok){
          this.requestMessage = data.message;
          this.closeModal();
        }else{
          this.requestMessage = data.message
        }

      } catch (error) {
        console.error('Error sending request:', error);
        this.requestMessage = "An error occurred, please try again later"
      } finally {
        this.isLoading = false;
      }
    },
  }
 
  }

</script>

<style>


</style>